<template>
    <painel titulo="Regras de Acesso" icone="pi pi-sliders-h">
        <tabela
            :data="regras"
            dataKey="regraAcessoId"
            :globalFilterFields="['areaDescr', 'subAreaDescr', 'codRegraAcesso', 'descricaoRegraAcesso']"
            stateKey="dt-regrasacesso"
        >
            <template #conteudo>
                <Column field="selecionado">
                    <template #body="slotProps">
                        <Checkbox v-model="localRegrasAcessoSelecionadas" :value="slotProps.data.regraAcessoId" :disabled="desabilitarForm" />
                    </template>
                </Column>
                <Column field="codRegraAcesso" header="Código" :sortable="true">
                    <template #body="slotProps">
                        <span>{{ slotProps.data.codRegraAcesso }}</span>
                        <span :title="'Nível: ' + slotProps.data.nivel">{{ slotProps.data.codRegraAcesso }}</span>
                    </template>
                </Column>
                <Column field="descricaoRegraAcesso" header="Descrição" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.descricaoRegraAcesso }}
                    </template>
                </Column>
            </template>
        </tabela>
    </painel>
</template>

<script>
import RegrasServices from './services';

export default {
    props: {
        aplicacao: {
            type: Object,
        },

        acao: {
            type: String,
        },
    },
    components: {},
    emits: ['updateRegrasAcessoSelecionadas'],

    data() {
        return {
            regras: [],
            localRegrasAcessoSelecionadas: [],
        };
    },
    methods: {
        obterRegras() {
            this.$store.dispatch('addRequest');
            RegrasServices.obterTodasRegrasAcesso().then((response) => {
                if (response?.success) {
                    this.regras = response.data;
                } else {
                    this.regras = null;
                }
                this.$store.dispatch('removeRequest');
            });
        },
    },
    watch: {
        localRegrasAcessoSelecionadas() {
            this.$emit('updateRegrasAcessoSelecionadas', this.localRegrasAcessoSelecionadas);
        },

        aplicacao() {
            this.regras = this.aplicacao.regrasAcesso;
            this.localRegrasAcessoSelecionadas = this.regras.map((item) => {
                return item.regraAcessoId;
            });
        },
        acao(val, oldval) {
            if (oldval == 'D') {
                this.obterRegras();
            } else if ((oldval == 'A' || oldval == 'I') && this.aplicacao) {
                this.regras = this.aplicacao.regrasAcesso;
                this.localRegrasAcessoSelecionadas = this.regras.map((item) => {
                    return item.regraAcessoId;
                });
            }
        },
    },
    created() {
        if (this.acao == 'I') {
            this.obterRegras();
        }
    },
    computed: {
        desabilitarForm() {
            return this.acao == 'D';
        },
    },
};
</script>
